import React from "react";
import {
	Avatar,
	Box,
	Container,
	Flex,
	Heading,
	Img,
	Link,
	Text,
} from "@chakra-ui/react";

const TheContextEconomyBlog: React.FC = () => (
	<>
		<Flex
			flexDirection="column"
			overflow="hidden"
			justify="center"
			height="100%"
			py={{ xs: "30px", sm: "40px", md: "60px", lg: "80px" }}
			h="100%"
			minH={{ xs: "400px", lg: "400px" }}
			maxH={{ xs: "400px", lg: "400px" }}
			pos="relative"
		>
			<Img
				pos="absolute"
				objectFit="cover"
				src="/webp/theContext-bg.webp"
				alt="members-hero"
				height="100%"
				width="100%"
			/>
			<Box
				bg="linear-gradient(78.35deg, rgba(13, 96, 81, 0.8) 18.38%, rgba(83, 92, 143, 0.8) 86.05%)"
				pos="absolute"
				height="100%"
				width="100%"
				opacity="0.7"
			/>
			<Container
				display="flex"
				as="section"
				maxW="container.xl"
				position="relative"
				zIndex="1"
				flexDir={{ xs: "column", md: "row" }}
				columnGap="24px"
				rowGap="30px"
				alignItems={{ xs: "flex-start", md: "flex-start" }}
				px={{ xs: "14px", sm: "28px", md: "45px", lg: "60px", xl: "inherit" }}
			>
				<Flex flexDir="column" rowGap="16px">
					<Heading
						color="white"
						fontSize={{ xs: "36px", sm: "42px", lg: "64px" }}
						fontWeight="800"
						lineHeight={{ xs: "35px", lg: "83px" }}
					>
						#TheContext
					</Heading>
					{/* <Heading
            color="white"
            fontSize={{ xs: '28px', sm: '34px' }}
            fontWeight="500"
            lineHeight="32px"
          >
            - By IVCA
          </Heading> */}
				</Flex>
				<Box
					w="1.5px"
					h={{ md: "200px", lg: "300px", xl: "230px" }}
					bgColor="white"
					display={{ xs: "none", md: "block" }}
				/>
				<Box
					w={{ xs: "70%", sm: "60%" }}
					h="1.5px"
					bgColor="white"
					display={{ xs: "block", md: "none" }}
				/>
				<Flex flexDir="column" rowGap="8px">
					<Heading
						as="h1"
						mb={{ xs: "10px", md: "20px" }}
						variant="reportCardTitle"
						fontSize={{ xs: "27px", sm: "29px", md: "32px", lg: "54px" }}
						color="white"
						lineHeight={{ xs: "36px", sm: "40px", md: "46px", lg: "70.2px" }}
					>
						AIFs – Empowering Indian Economy
					</Heading>
					<Text
						fontSize={{ xs: "18px", sm: "18px", md: "20px", lg: "22px" }}
						fontWeight="600"
						color="white"
						lineHeight="28px"
					>
						Tejesh Chitlangi
					</Text>
					<Text
						fontSize={{ xs: "18px", sm: "18px", md: "20px", lg: "22px" }}
						fontWeight="600"
						color="white"
						lineHeight="28px"
					>
						Leelavathi Naidu
					</Text>
				</Flex>
			</Container>
		</Flex>
		<Container maxW="container.xl" pb="80px" pt="40px">
			<Flex
				flexDir={{ xs: "column-reverse", md: "row" }}
				px={{ xs: "8px", md: "0px" }}
			>
				<Flex
					w={{ xs: "100%", md: "27%" }}
					mt={{ xs: "32px", md: "0px" }}
					flexDir="column"
					rowGap="16px"
					mr={{ xs: "0px", md: "40px" }}
					ml={{ xs: "0px", sm: "10px" }}
					mb={{ xs: "16px", md: "8px" }}
				>
					<Heading
						fontSize="22px"
						lineHeight="22px"
						textAlign={{ xs: "center", sm: "left" }}
					>
						Follow the Authors
					</Heading>
					<Box
						w="100%"
						h="1.5px"
						bg="linear-gradient(93.48deg, #00001F 45.8%, #186658 74.6%)"
						my="8px"
					/>
					{[
						{
							name: "Tejesh Chitlangi",
							position: "Joint Managing Partner",
							linkedin:
								"https://www.linkedin.com/in/ravi-chopra-364b9a56/?originalSubdomain=uk",
							image:
								"https://static.levocdn.com/WGLBUT82/Tejesh%20Chitlangi-7166791437512845285.jpeg",
						},
						{
							name: "Leelavathi Naidu",
							position: "Partner (IC Universal Legal)  ",
							linkedin:
								"https://www.linkedin.com/in/jacqui-eaves/?originalSubdomain=uk",
							image:
								"https://static.levocdn.com/WGLBUT82/LEELAVATHI-NAIDU-1-7166791437529515070.png",
						},
					].map((item, index) => (
						<Flex
							key={index}
							flexDir={{ xs: "column", sm: "row", md: "column" }}
							columnGap="20px"
							rowGap="16px"
						>
							<Flex
								flexDir="column"
								alignItems={{ xs: "center", sm: "flex-start" }}
								rowGap="8px"
							>
								<Box boxSize="95px" borderRadius="50%" overflow="hidden">
									<Avatar
										name={item.name}
										w="100%"
										h="100%"
										src={item.image}
										objectFit="cover"
									/>
								</Box>
								<Flex flexDir="column" rowGap="4px">
									<Heading
										variant="blogQuestion"
										textAlign={{ xs: "center", sm: "left" }}
									>
										{item.name}
									</Heading>
									<Text
										variant="blogAnswer"
										textAlign={{ xs: "center", sm: "left" }}
										fontStyle="italic"
									>
										{item.position}
									</Text>
								</Flex>
							</Flex>
						</Flex>
					))}
				</Flex>

				<Box w={{ xs: "100%", md: "73%" }}>
					<Text variant="blogAnswer" mb="20px">
						As India ushers into the Amrit Kaal, ‘ease of doing business’ whilst
						ensuring good governance has become the central theme of the
						regulatory framework surrounding the Alternative Investment Funds
						(AIFs).
					</Text>
					<Text variant="blogAnswer" pb="20px">
						The AIF industry in India is experiencing significant growth, and
						institutions such as the International Monetary Fund and the World
						Bank have acknowledged India as an economic bright spot amidst
						global challenges. With just over a decade of regulatory existence,
						the AIF fraternity has grown to 1275+ strong and has raised in
						excess of INR 11 trillion in commitments.
					</Text>
					<Text variant="blogAnswer" pb="20px">
						Keeping up with the pace of growth of AIFs, the Sebi (AIF)
						Regulations 2012 have also undergone significant changes since
						inception of the regulatory regime. Most of the recent regulatory
						requirements viz. transparency and trail mode of payment of
						distributor commission, dematerialization and simplification of the
						process for accreditation, permitting further extension of the term
						of the fund beyond the original period with regulatory safeguards
						etc. have been welcomed by the industry as these would be leading to
						long-term sustainable growth. At the same time, industry is also
						looking for more regulatory guidance on priority distributions,
						permissibility of encumbrance of assets of investee companies, some
						relaxation in the overall regulatory framework to cut on certain
						overlapping compliances and measures for promoting ease of doing
						business.
					</Text>
					<Text variant="blogAnswer" pb="20px">
						SEBI has been notifying various possible relaxations for the
						deepening of the domestic institutional investor base in the AIFs.
						For instance, permitting excuse clauses for investors wherein
						certain underlying exposures cannot be directly/indirectly
						undertaken by an investor, is a welcome move and, inter alia,
						provides regulatory assurance to the likes of insurance companies
						and pension funds that their investments in AIFs will not result in
						any prohibited overseas exposures for such class of investors.
					</Text>
					<Text variant="blogAnswer" pb="20px">
						Industry expects the Regulators like SEBI, RBI, IRDAI, PFRDA to take
						all possible measures for strengthening of the domestic funds
						industry by ensuring maximum participation from domestic
						institutions in this asset class so that the quality long term
						capital can timely get channelised to Indian portfolio entities.
						Hence one of the major regulatory support that the industry is
						looking forward to, is a collaborative effort between regulatory
						authorities and market participants to ensure a robust growth of the
						entire investment eco-system. This is also critical for the success
						of important Government themes like “Make in India” and
						“Self-Reliant India”. Industry associations like IVCA also have been
						playing an important role in the orderly development of the AIF
						industry through its several innovative initiatives.
					</Text>
					<Text variant="blogAnswer" pb="20px">
						With the various steps taken over the past several years ensuring
						investor protection and transparency in day to day conduct of the
						AIFs, the industry is hopeful that these measures will continue
						bringing in and even accelerate the flow of global capital in AIFs
						as the Indian regulatory regime is at par or even better than what’s
						prevailing in developed jurisdictions. The AIF industry is poised to
						grow significantly, has matured over the past decade and is ready to
						act as a significant contributor to the success and further rise of
						the Indian Economy.
					</Text>
				</Box>
			</Flex>
			<Box w="100%" h="1.5px" mt="16px" mb="8px" bgColor="gray.700" />
			<Text variant="blogAnswer" fontStyle="italic" p="12px 12px 0px">
				<Heading variant="blogQuestion" fontStyle="normal" as="span">
					#TheContext by IVCA{" "}
				</Heading>
				– features opinion makers from the alternate investing industry with
				strong focus on India as investment destination. Watch this space for
				viewpoints on investment themes, emerging trends, economic analysis and
				latest industry insights.
			</Text>
			<Heading
				variant="blogQuestion"
				lineHeight="30px"
				pt="16px"
				fontStyle="italic"
				p="12px 12px 0px"
			>
				Content in this section is curated by team IVCA. To share feedback,
				connect with &nbsp;
				<Link
					href="mailto:paromita.sinha@ivca.in"
					target="_blank"
					style={{ color: "blue", textDecoration: "underline" }}
				>
					paromita.sinha@ivca.in
				</Link>
			</Heading>
		</Container>
	</>
);

export default TheContextEconomyBlog;
